// Used to pull raw runData and display built files (namely the runTImings and racerFacts) and then if they look
// good write them back as their own blobs in the run table.

// need to add ability to:
// get current status: isProdReady, has runTImings, has racerFacts
// toggle isProdReady field from 'yes' to 'no' in run table
// overwrite runTImings and racerFacts if needed

// pullData()
// buildBlobs()
// viewBlobs()
// provideWarnings()
// pushBlobs() -- work on this now.

// then clean up calculateInitialLapTiming to clean up old array stuff
// then refactor makeEventList to use the object instead of hacked array.
// then rework how each thing is called and put into state before writing back to DB.

// Later it also needs a function to look at latest events from race hero and fire off the initial data pull to populate events table.

// import '@aws-amplify/ui-react/styles.css';
import ReactJson from 'react-json-view';
import React, { useState, useEffect, useContext } from 'react';
import { API } from 'aws-amplify';
import { GlobalContext } from '../GlobalState';
import {
  useAuthenticator,
  Button,
  Flex,
  Heading,
  View,
  SelectField,
  Divider,
  Badge,
  Text,
  Alert,
  TextField,
  Expander,
  ExpanderItem,
} from '@aws-amplify/ui-react';
import {
  listEventLists,
  getRunDetail,
  listVideoData,
  echo,
} from '../../graphql/queries';
import { updateRunDetail as updateRunMutation } from '../../graphql/mutations';
import { DataGrid } from '@mui/x-data-grid';
import { VideoDetailCard } from './VideoDetailCard';
import { VideoDebugTable } from './VideoDebugTable';

const axios = require('axios').default;
const rh_api_uname = 'c05d07001e68143bd81a';

const calcDebugColumns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'racerNumber', headerName: 'racerNumber', width: 100 },
  { field: 'racerClass', headerName: 'racerClass', width: 100 },
  { field: 'totalLaps', headerName: 'totalLaps', width: 80 },
  {
    field: 'totalCalculatedLapTime',
    headerName: 'totalCalculatedLapTime',
    width: 100,
  },
  { field: 'totalTime', headerName: 'totalTime', width: 120 },
  { field: 'timeDiff', headerName: 'startLineOffsetToP1', width: 125 },
  { field: 'startPosition', headerName: 'startPosition', width: 100 },
  { field: 'finishPosition', headerName: 'finishPosition', width: 100 },
  { field: 'gapToP1', headerName: 'gapToP1', width: 100 },
  { field: 'gapToAhead', headerName: 'gapToAhead', width: 100 },
  { field: 'isLapped', headerName: 'isLapped', width: 100 },
  //   { field: 'fudged_offset', headerName: 'fudged_offset', width: 100 },
  { field: 'lappedTimeDiff', headerName: 'lappedTimeDiff', width: 100 },
  { field: 'laps', headerName: 'lapDetails', width: 180 },
];

// function ActiveItem({ name, data, filter }) {
//   const event = filter[0];
//   const group = filter[1];
//   const run = filter[2];
//   // console.log(event, group, run);
//   if (event === data.eventId) {
//     return (
//       <li>
//         Event:{data.eventId} Group:{data.groupId} Run:{data.runId}
//       </li>
//     );
//   }
// }

export const AlertHeadingExample = () => {
  return (
    <>
      <Alert variation="warning">This Alert does not have a heading</Alert>
      <Alert variation="success" heading="This is the heading">
        Cool heading!
      </Alert>
    </>
  );
};

// this is also in htr-buildEvents.js - should create a raceHero module
async function getRunDetails(event_id, run_id) {
  let response = await axios.get(
    `https://racehero.io/api/v1/events/${event_id}/runs/${run_id}/results`,
    {
      auth: { username: rh_api_uname, password: '' },
      params: { expand: 'laps,flags,notes' },
    }
  );
  if (response.data) {
    const result = response.data;
    const runId = response.data.run.id;
    const eventId = response.data.event.id;
    const groupId = response.data.group.id;
    result.run_id = runId;
    result.event_id = eventId;
    result.group_id = groupId;
    // console.log(result);
    return result;
  } else {
    console.log('nothing returned');
  }
}

export const VideoAdmin = () => {
  const { activeProfile } = useContext(GlobalContext);
  // console.log(activeProfile);
  const { user } = useAuthenticator((context) => [context.user]);
  const groups = user.signInUserSession.accessToken.payload['cognito:groups'];
  const [eventsData, setEventsData] = useState([]);
  const [eventId, setEventId] = useState();
  const [groupIds, setGroupIds] = useState([]);
  const [groupId, setGroupId] = useState();
  const [runIds, setRunIds] = useState([]);
  const [runId, setRunId] = useState();
  const [runDetails, setRunDetails] = useState(''); // same as runJson aka raceResults
  const [racerList, setRacerList] = useState([]); // raw racer list from runDetails
  const [racerDetails, setRacerDetails] = useState([]); // formatted (final) racer list to write back
  const [runTimings, setRunTimings] = useState({});
  const [calculatedInitialGapDebug, setCalculatedInitialGapDebug] = useState(
    []
  );
  const [refactoredInitialGap, setRefactoredInitialGap] = useState([]);
  const [myEventList, setMyEventList] = useState([]);
  const [isProdReadyState, setIsProdReadyState] = useState('no');
  // current run states when loaded
  const [runNotes, setRunNotes] = useState('');
  const [currentRunVersion, setCurrentRunVersion] = useState();
  const [currentIsReadyState, setCurrentIsReadyState] = useState('no');
  const [currentHasRacerDetailState, setCurrentHasRacerDetailState] =
    useState('no');
  const [currentHasRunTimingsState, setCurrentHasRunTimingsState] =
    useState('no');
  const [videoData, setVideoData] = useState();
  const [rHrunJson, setRhRunJson] = useState({}); //maybe same as runDetails?

  const [echoResponse, setEchoResponse] = useState([]);
  const [echoResponse2, setEchoResponse2] = useState([]);

  useEffect(() => {
    fetchVideoData();
    fetchEventsData();
  }, []);

  // duplicate funcitons from buildRunDetails for now
  // takes the racerList already in state and coverts it to the desired final format
  async function formatRacerDetails(racer_list) {
    const racerMap = [];
    for (const r of racer_list) {
      racerMap.push([r.racer_number, r.racer_class, r.name]);
    }
    setRacerDetails(racerMap);
  }

  function roundTo(n, digits) {
    var negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);
    if (negative) {
      n = (n * -1).toFixed(digits);
    }
    return n;
  }

  function calculateInitialGap(race_results) {
    let diffArray = [];
    let diffObjArray = [];
    let calculatedGapDebugArray = [];
    for (const r of race_results.results) {
      let racerNumber = r.racer_number;
      let totalLaps = r.total_laps;
      let totalTime = r.total_time;
      let gapToP1 = r.gap_to_p1_in_run;
      let gapToAhead = r.gap_to_ahead_in_run;
      let finishPosition = r.position_in_run;
      let startPosition = r.start_position_in_run;
      let racerClass = r.racer_class;
      let laps = r.laps;

      if (gapToP1 === 'DNS' || gapToP1 === 'DNF' || laps.length === 0) {
        continue;
      }

      let totalCalculatedLapTime = 0;
      for (const l of r.laps) {
        totalCalculatedLapTime = totalCalculatedLapTime + l.time;
      }
      totalCalculatedLapTime = roundTo(totalCalculatedLapTime, 3);
      let timeDiff = roundTo(totalTime - totalCalculatedLapTime, 3); //crossed start line relative to P1
      // Fudge cars who finished lap(s) down
      let lappedCar = false;
      let lappedTimeDiff;
      if (gapToP1.includes('Lap')) {
        lappedCar = true;
        if (startPosition === 1) {
          //rare situation where P1 starter gets lapped. fudge to zero
          lappedTimeDiff = timeDiff;
          timeDiff = 0.0;
        } else {
          lappedTimeDiff = timeDiff;
          timeDiff = 99999;
        }
      }

      // Using Array - clean this up later after moving to array of objects
      diffArray.push([racerNumber, Number(timeDiff), startPosition]);
      // handle lapped cars by sorting in starting order and adding 2 tenths to prior cars starting offset
      //   console.log({ lappedCars });
      diffArray = diffArray.sort(function (a, b) {
        return a[2] - b[2];
      });

      // with objects

      function makeLapString(laps_array) {
        // number, time, position
        const lapNumbers = laps_array.map((lap) => {
          return lap.number;
        });
        const lapNumbersString = lapNumbers.toString();
        return lapNumbersString;
      }
      const initialGapDebugObject = {
        id: `${racerNumber}_${startPosition}`, // to account for NASA non-unique car numbers
        // id: racerNumber,
        racerNumber: racerNumber,
        racerClass: racerClass,
        totalLaps: totalLaps,
        totalTime: totalTime,
        gapToP1: gapToP1,
        gapToAhead: gapToAhead,
        finishPosition: finishPosition,
        startPosition: startPosition,
        totalCalculatedLapTime: totalCalculatedLapTime,
        timeDiff: timeDiff,
        lappedTimeDiff: lappedTimeDiff,
        isLapped: lappedCar,
        fudged_offset: '',
        laps: makeLapString(laps),
        lapObject: laps,
      };
      calculatedGapDebugArray.push(initialGapDebugObject);
      diffObjArray.push(initialGapDebugObject);
    }
    diffObjArray = diffObjArray.sort(function (a, b) {
      return a.startPosition - b.startPosition;
    });
    // with arrays
    let finalizedArray = [];
    let previousCarOffset = 0;
    for (const c of diffArray) {
      let carNum = c[0];
      let offset = c[1];
      let stPos = c[2];
      if (offset === 99999) {
        offset = previousCarOffset + parseFloat(0.2); // Add two tenths to prior cars offset
      }
      previousCarOffset = offset;
      finalizedArray.push([carNum, Number(offset), stPos]);
    }

    diffObjArray.forEach((car, i) => {
      const previousIndex = i - 1;
      if (car.isLapped && car.startPosition !== 1) {
        car.timeDiff =
          Number(diffObjArray[previousIndex]?.timeDiff) + parseFloat(0.5);
      }
    });

    // create the array out of the this object for now
    // [[carNum,offset,startPosition]]
    const legacyArray = diffObjArray.map((entry) => {
      return [entry.racerNumber, Number(entry.timeDiff), entry.startPosition];
    });

    setRefactoredInitialGap(legacyArray);
    setCalculatedInitialGapDebug(diffObjArray);
    // return finalizedArray;
    return legacyArray;
  }

  function makeEventList(initial_gap_array, race_results) {
    let eventList = [];
    for (const i of initial_gap_array) {
      const carNum = i[0];
      const initialGap = Number(i[1]);
      for (const r of race_results.results) {
        const racerNumber = r.racer_number;
        const startingPosition = r.start_position_in_run;
        const lapz = r.laps;
        const gapToP1 = r.gap_to_p1_in_run;
        if (gapToP1 === 'DNS' || gapToP1 === 'DNF' || lapz.length === 0) {
          //kpw check if this is issue needing also DNF
          continue;
        }
        if (carNum === racerNumber) {
          let carLapArrayPre = [];
          for (const l of r.laps) {
            carLapArrayPre.push([l.number, Number(l.time), l.position]);
          }
          //first sort, then make cumulative
          let sortedArray = carLapArrayPre.sort(function (a, b) {
            return a[0] - b[0];
          });
          // console.log(carNum);
          // console.log(sortedArray);
          // lapNumber, eventAbsoluteTime, carNumber, position, lapTime
          const resultingArray = [
            [0, Number(roundTo(initialGap, 3)), carNum, startingPosition, 0],
          ]; //Initial lap zero
          let sortedArrayIndex = 0; //should always be one less than lap number but isnt due to RaceHero issues
          for (const s of sortedArray) {
            const lap = s[0];
            const lapTime = Number(s[1]);
            // console.log(`lapTime: ${lapTime}`);
            const position = s[2];
            let previousLapNum = lap - 1;
            // console.log(`previousLapNum: ${previousLapNum}`);
            // console.log(resultingArray[previousLapNum]);
            if (resultingArray[previousLapNum] === 'undefined')
              console.log(
                `Something weird in the RaceHero lap numbering.  Trying index instead of lapnum`
              );
            previousLapNum = sortedArrayIndex;
            let previousCummTime = Number(resultingArray[previousLapNum][1]);
            // console.log(`previousCummTime: ${previousCummTime}`);
            let cummTime = Number(roundTo(previousCummTime + lapTime, 3));
            if (cummTime === 'undefined')
              console.log(`no cummTime from car ${carNum} lap ${lap}`);

            resultingArray.push([lap, cummTime, carNum, position, lapTime]);
            sortedArrayIndex = sortedArrayIndex + 1;
          }
          // console.log(resultingArray);
          eventList = eventList.concat(resultingArray);
        }
      }
    }
    eventList = eventList.sort(function (a, b) {
      return a[1] - b[1];
    });
    // console.log(eventList);
    setMyEventList(eventList);
    return eventList;
  }

  async function buildRaceTimings(run_data) {
    const result = await makeEventList(calculateInitialGap(run_data), run_data);
    setRunTimings(result);
  }

  async function getGroupIds(event_id) {
    const activeEvent = eventsData?.filter(
      (eve) => eve.id === Number(event_id)
    );
    setGroupIds(activeEvent[0]?.groups);
  }

  async function getRunIds(group_id) {
    const activeGroup = groupIds.filter((grp) => grp.id === Number(group_id));
    setRunIds(activeGroup[0]?.runs);
  }

  // grab event data from API
  async function fetchEventsData() {
    let eventData = [];
    try {
      const apiData = await API.graphql({
        query: listEventLists,
        // variables: { filter: myFilter },
      });
      const eventsFromAPI = apiData.data.listEventLists.items;
      for (const ev of eventsFromAPI) {
        const eventJson = JSON.parse(ev.eventJson);
        eventData.push(eventJson);
      }
      eventData.sort((a, b) => new Date(b.started_at) - new Date(a.started_at));
      setEventsData(eventData);
    } catch (error) {
      console.log(error);
    }
  }
  // need to catch null or empty string ''
  async function setCurrentStatuses(run_response) {
    const currentIsReadyState =
      run_response.isProdReady === 'yes' ? 'yes' : 'no';
    const currentHasRacerDetailState =
      run_response.racerFacts !== null ? 'yes' : 'no';
    const currentHasRunTimingsState =
      run_response.runTimings !== null ? 'yes' : 'no';
    // add one for isProdReady
    setRunNotes(run_response.runNotes);
    setCurrentRunVersion(run_response._version);
    setCurrentIsReadyState(currentIsReadyState);
    setCurrentHasRacerDetailState(currentHasRacerDetailState);
    setCurrentHasRunTimingsState(currentHasRunTimingsState);
  }

  // fetch video details from API - getting all of it for now.  Should probably filter.
  async function fetchVideoData() {
    try {
      const apiData = await API.graphql({
        query: listVideoData,
        // variables: { filter: myFilter },
        // variables: { id: run_id },
      });
      const r = apiData.data.listVideoData.items;
      // console.log(r);
      // const runVersion = r._version;
      // const runJson = JSON.parse(runResponse.runJson);
      setVideoData(r);
    } catch (error) {
      console.log(error);
    }
  }

  async function updateEventsForNasaScca() {
    await updateEventsFromRh(2418);
    await updateEventsFromRh(34);
  }
  async function updateEventsFromRh(org_id) {
    try {
      const apiData = await API.graphql({
        query: echo,
        variables: { org_id: org_id },
      });
      const r = apiData.data.echo;
      console.log('echo response stuff');
      console.log(typeof r);
      console.log(r);
      console.log(typeof r.body);
      console.log(r.body);
      const res = JSON.parse(r.body);
      console.log(typeof res);
      console.log(res);
      setEchoResponse(res);
      fetchEventsData();
    } catch (error) {
      console.log(error);
      setEchoResponse(error);
    }
  }
  // the next two functions are in shared, but will need to refactor a bit  to replace the below.
  async function updateRunFromRh(event_id, run_id) {
    console.log('updateRunFromRh', event_id, run_id);
    try {
      const apiData = await API.graphql({
        query: echo,
        variables: { event_id: Number(event_id), run_id: Number(run_id) },
      });
      const r = apiData.data.echo;
      console.log('updateRunFromRh response stuff');
      console.log(typeof r);
      console.log(r);
      console.log(typeof r.body);
      console.log(r.body);
      const res = JSON.parse(r.body);
      console.log(typeof res);
      console.log(res);
      setEchoResponse2(res);
      fetchRunDetails(run_id);
    } catch (error) {
      console.log(error);
      setEchoResponse2(error);
    }
  }
  // fetch run details from API
  async function fetchRunDetails(run_id) {
    // check if run.status is PROVISIONAL or anything other than FINAL and then
    // update the Runtable from RaceHero (overwrite runJson).  Might also need to
    // check run.has_results === true
    // can check this from runIds in state
    // console.log(runIds);
    // runIds.forEach((run) => console.log(run.id));
    // const rundeets = runIds.filter((run) => run.id === Number(run_id));
    // if (!rundeets || rundeets[0].status !== 'FINAL') {
    //   console.log('do the thing to update the runJson from RaceHero');
    //   const raceHeroRunDetails = getRunDetails(eventId, run_id);
    //   setRhRunJson(raceHeroRunDetails); // cors issue
    //   await updateRunJson(raceHeroRunDetails);
    // }
    try {
      const apiData = await API.graphql({
        query: getRunDetail,
        variables: { id: run_id },
      });
      const r = apiData.data.getRunDetail;
      console.log(r);
      if (r === null) {
        console.log('we need to populate our DB with the event from RaceHero');
        updateRunFromRh(eventId, run_id);
      } else {
        const runResponse = r;
        const runVersion = r._version;
        const runJson = JSON.parse(runResponse.runJson);
        setCurrentStatuses(runResponse);
        setRunDetails(runJson);
        setRacerList(runJson.racers);
        formatRacerDetails(runJson.racers);
        buildRaceTimings(runJson);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const filter__updateRunTimings = {
    id: runId,
    runTimings: JSON.stringify(myEventList),
    racerFacts: JSON.stringify(racerDetails),
    _version: currentRunVersion,
  };

  const filter__updateIsProdReady = {
    id: runId,
    _version: currentRunVersion,
    isProdReady: currentIsReadyState === 'yes' ? 'no' : 'yes', //need to make opposite of current state
  };

  const filter__updateRunJson = {
    id: runId,
    _version: currentRunVersion,
    runJson: rHrunJson,
  };

  const filter__updateRunNote = {
    id: runId,
    _version: currentRunVersion,
    runNotes: runNotes,
  };
  // update run notes
  async function updateRunNote(event) {
    event.preventDefault();
    const form = new FormData(event.target);
    const data = {
      id: runId,
      _version: currentRunVersion,
      runNotes: form.get('note'),
    };
    console.log(data);
    try {
      const apiData = await API.graphql({
        query: updateRunMutation,
        variables: { input: data },
      });
      const r = apiData.data.updateRunDetail;
      console.log(r);
      // update state for
      setRunDetails(r);
      setCurrentStatuses(r);
      setRunNotes('');
      form.note = '';
    } catch (error) {
      console.log(error);
    }
  }

  // update run details from API
  async function updateRunTimings() {
    try {
      const apiData = await API.graphql({
        query: updateRunMutation,
        variables: { input: filter__updateRunTimings },
      });
      const r = apiData.data.updateRunDetail;
      console.log(r);
      // update state for
      setRunDetails(r);
      setCurrentStatuses(r);
    } catch (error) {
      console.log(error);
    }
  }

  // update runJson from raceHero data
  // kpw finish this by updating smo state
  async function updateRunJson() {
    console.log(rHrunJson);
    console.log(runDetails);
    try {
      const apiData = await API.graphql({
        query: updateRunMutation,
        variables: { input: filter__updateRunJson },
      });
      const r = apiData.data.updateRunDetail;
      console.log(r);
      // update state for
      setRunDetails(r); // no
      setCurrentStatuses(r); // no
    } catch (error) {
      console.log(error);
    }
  }

  // update run details from API
  async function updateIsProdReady() {
    try {
      const apiData = await API.graphql({
        query: updateRunMutation,
        // variables: { filter: myFilter },
        variables: { input: filter__updateIsProdReady },
      });
      const r = apiData.data.updateRunDetail;
      console.log('updated ready state');
      console.log(r);
      // update state for
      //   setRunDetails(r);
      setCurrentStatuses(r);
      //   setIsProdReadyState(r);
    } catch (error) {
      console.log(error);
    }
  }

  async function resetStates() {
    setRunId('');
    setRunIds([]);
    setRunDetails('');
    setRunNotes('');
    setCurrentHasRacerDetailState('no');
    setCurrentHasRunTimingsState('no');
    setCurrentIsReadyState('no');
  }
  // restrict entire page to Admin's only
  // would be better to implment as redirect to unauthorized page so I don't need an 'else'
  if (!groups || !groups.includes('Admin')) {
    console.log('you not in Admin group');
    return <View>Not Authorized</View>;
  } else {
    return (
      <View textAlign="center">
        <Heading level={1}>ADMIN Page</Heading>
        <Flex justifyContent="center" wrap="wrap">
          <View as="form" width="90%">
            <Flex direction="row" justifyContent="center" wrap="wrap">
              <SelectField
                width="30%"
                name="eventid"
                label="RaceHero EventId"
                value={eventId}
                placeholder="Select Event"
                defaultValue="none "
                required
                onChange={(e) => {
                  resetStates();
                  setEventId(e.target.value);
                  getGroupIds(e.target.value);
                }}
              >
                {eventsData.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.id} - {option.started_at} - {option.name} -{' '}
                    {option.venue.name}
                  </option>
                ))}
              </SelectField>
              <SelectField
                name="groupid"
                width="30%"
                label="RaceHero GroupId"
                value={groupId}
                placeholder="select group"
                required
                onChange={(e) => {
                  resetStates();
                  setGroupId(e.target.value);
                  getRunIds(e.target.value);
                }}
              >
                {groupIds?.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.id} - {option.name}
                  </option>
                ))}
              </SelectField>
              <SelectField
                name="runid"
                width="30%"
                label="RaceHero RunId"
                value={runId}
                placeholder="select run"
                required
                onChange={(e) => {
                  setRunId(e.target.value);
                  fetchRunDetails(e.target.value);
                }}
              >
                {runIds?.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.id} - {option.started_at} - {option.name} -{' '}
                    {option.status === 'PROVISIONAL' ? 'update me' : 'all good'}{' '}
                    - {option.has_results}
                  </option>
                ))}
              </SelectField>
            </Flex>
            <View padding="medium">
              <Button onClick={updateEventsForNasaScca}>Update Events</Button>
              <Button onClick={updateRunTimings}>Update Run Timings</Button>
              <Button onClick={updateIsProdReady}>Toggle Prod Ready</Button>
            </View>
            {/* <View>
              Response from echo
              <div>{!echoResponse ? 'no response' : typeof echoResponse}</div>
            </View> */}
          </View>
        </Flex>
        <Flex justifyContent="center" wrap="wrap">
          <Text>Current Run Status:</Text>
          <Badge
            key="123"
            backgroundColor={runDetails !== '' ? 'green.40' : 'red.40'}
          >
            runDetails
          </Badge>
          <Badge
            key="456"
            backgroundColor={
              currentHasRacerDetailState === 'yes' ? 'green.40' : 'red.40'
            }
          >
            racerDetail
          </Badge>
          <Badge
            key="789"
            backgroundColor={
              currentHasRunTimingsState === 'yes' ? 'green.40' : 'red.40'
            }
          >
            runTimings
          </Badge>
          <Badge
            key="222"
            backgroundColor={
              currentIsReadyState === 'yes' ? 'green.40' : 'red.40'
            }
          >
            isProdReady
          </Badge>
        </Flex>
        <View as="form" padding="large" onSubmit={updateRunNote}>
          <Flex direction="column" justifyContent="center">
            <Text>Notes: {runDetails?.runNotes}</Text>
            <TextField
              name="note"
              defaultValue={runNotes}
              errorMessage="There is an error"
            />
            <Button type="submit" variation="link" size="small">
              Update Note
            </Button>
          </Flex>
        </View>
        <Divider padding="medium" />
        <Flex justifyContent="center">
          <View as="div" style={{ height: 400, width: '90%' }} padding="medium">
            <Heading level="3">First Lap Timing Calculations</Heading>
            <DataGrid
              rows={calculatedInitialGapDebug}
              columns={calcDebugColumns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              //   checkboxSelection
              density={'compact'}
              onCellClick={(params, event) => {
                console.log(
                  params.row.racerNumber,
                  runDetails?.results.filter(
                    (res) => res.racer_number === params.row.racerNumber
                  )
                );
              }}
            />
          </View>
        </Flex>
        <Divider padding="medium" />
        <Flex justifyContent="center">
          <View as="div" style={{ height: 400, width: '90%' }} padding="medium">
            <Heading level="3">Videos related to this event_run</Heading>
            {videoData && (
              <VideoDebugTable
                rows={
                  !videoData ? [] : videoData.filter((e) => e.runId === runId)
                }
              ></VideoDebugTable>
            )}
          </View>
        </Flex>
        <Divider padding="medium" />
        <Flex justifyContent="center">
          <View as="div" style={{ height: 400, width: '90%' }} padding="medium">
            <Heading level="3">DebugInfo</Heading>
            {runDetails && (
              <View as="div" maxWidth="80%" align="left">
                <div>
                  {eventId}_{runId}
                </div>
                <Expander type="single" isCollapsible={true}>
                  <ExpanderItem title="Run Timings" value="runtimings">
                    {runTimings.map((line, i) => (
                      <pre key={i}>{JSON.stringify(line)}</pre>
                    ))}
                  </ExpanderItem>
                  <ExpanderItem title="Racer Detail" value="racerdetail">
                    {racerDetails.map((line, i) => (
                      <pre key={i}>{JSON.stringify(line)}</pre>
                    ))}
                  </ExpanderItem>
                  <ExpanderItem title="Run Detail" value="rundetail">
                    <ReactJson
                      src={runDetails}
                      collapsed="true"
                      style={{ justifyContent: 'left' }}
                      theme="monokai"
                    />
                    {/* <pre>{JSON.stringify(runDetails)}</pre> */}
                  </ExpanderItem>
                </Expander>
              </View>
            )}
          </View>
        </Flex>
      </View>
    );
  }
};
